<template>
  <div
    v-on-click-outside="onClickOutsideHandler"
    class="flex cursor-default flex-col items-stretch space-y-1 px-3 py-3 text-left"
  >
    <div class="space-y-1 text-gray-500">
      <p class="w-full break-normal whitespace-pre-line">
        {{ $t("COMMON.REPLACE") }}
        <span class="font-bold">{{ replaceFrom }}</span>
      </p>
      <p>
        {{ $t("COMMON.WITH") }}
        <span class="font-bold">{{ replaceTo }}</span>
        ?
      </p>
      <p class="text-gray-500">
        {{ $t("ORCHESTRATION.CONDITIONAL_ATTRIBUTES_DELETED") }}
      </p>
    </div>
    <div class="flex justify-end">
      <button
        class="mr-3 cursor-pointer font-semibold text-gray-500"
        @click.stop="cancelReplace"
      >
        {{ $t("COMMON.DISMISS") }}
      </button>
      <button
        class="cursor-pointer font-semibold text-blue-600"
        @click.stop="replaceStep"
      >
        {{ $t("COMMON.REPLACE") }}
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useStore } from "vuex";

defineProps<{ replaceFrom: string; replaceTo: string }>();

const { commit, dispatch } = useStore();

const cancelReplace = () => {
  dispatch("orchestration/cancelReplaceService");
};

const replaceStep = () => {
  dispatch("orchestration/replaceStep");
  commit("orchestration/setActiveConfigPanel", "");
  commit("orchestration/setActiveStep", {});
};

const onClickOutsideHandler = [cancelReplace, { capture: false }];
</script>
